/* eslint-disable react/no-multi-comp */
import React, { useState } from 'react'
import { Table, Button, Divider, Popconfirm, Row, Col, Tag, Icon, message } from 'antd'
import BrandActivityForm from './BrandActivityForm'
import BrandActivityStatusForm from './BrandActivityStatusForm'
import { ButtonEx } from '../../../styles/button.style'
import { ACTION } from '../../../utils/constants'
import { useDispatch, useSelector } from 'react-redux'
import { useDeepEffect } from '../../../utils/hooks'
import {
  createBrandActivity,
  deleteBrandActivity,
  fetchBrandActivityList,
  updateBrandActivity,
  updateBrandActivityStatus
} from '../../../modules/brandActivity'
import {
  uploadBrandActivityPhotoList,
  deleteBrandActivityPhotoList
} from '../../../utils/services'
import _ from 'lodash'
import PreviewImage from '../../../components/PreviewImage'
import { createActivityWebhook } from '../../../modules/brandActivityTransaction'
import { Modal } from 'antd';

const BrandActivity = ({ brandId }) => {
  const dispatch = useDispatch()
  const [visible, setVisible] = useState(false)
  const [visiblePreview, setVisiblePreview] = useState(false)
  const [previewImage, setPreviewImage] = useState(null)
  const [formState, setFormState] = useState(null)
  const [webhookDrafts, setWebhookDrafts] = useState([])
  const [action, setAction] = useState(ACTION.CREATE)
  const [visibleStatus, setVisibleStatus] = useState(false)
  const [formDataStatus, setFormDataStatus] = useState({})
  const [coverList, setCoverList] = useState([])
  const [removedImages, setRemovedImages] = useState([])

  const { brandActivityList, isLoading } = useSelector(
    (state) => ({
      brandActivityList: state.brandActivity.brandActivityList,
      isLoading: state.brandActivity.isLoading
    }),
    []
  )


  async function fetchData() {
    await dispatch(fetchBrandActivityList(brandId))
  }

  useDeepEffect(() => {
    fetchData()
  }, [])

  const handleUploadActivityPhotoList = async (fileList, activityId) => {
    const newFiles = fileList
      .filter((file) => !file.url)
      .map((file) => file.originFileObj)

    try {
      for (const file of newFiles) {
        await uploadBrandActivityPhotoList(file, activityId)
      }
    } catch (error) {
      console.error(error)
    }
  }

  const handleRemoveActivityPhotoList = async (file, activityId) => {
    try {
      const response = await deleteBrandActivityPhotoList(file.uid, activityId)
      if (response) {
        setCoverList((prevList) =>
          prevList.filter((item) => item.uid !== file.uid)
        )
      }
    } catch (error) {
      console.error('ลบรูปไม่สำเร็จ:', error)
    }
  }

  const columns = [
    {
      title: 'ID',
      key: 'id',
      dataIndex: 'id'
    },
    {
      title: 'ชื่อกิจกรรม',
      key: 'No',
      dataIndex: 'activityName'
    },
    {
      title: 'ระยะเวลากิจกรรม',
      dataIndex: 'rangeActiveDate',
      key: 'rangeActiveDate'
    },
    {
      title: 'Status',
      key: 'status',
      dataIndex: 'status',
      render: (status, record) => {
        let color
        switch (status) {
          case 'Active':
            color = 'green'
            break
          case 'Expire':
            color = 'red'
            break
          case 'Inactive':
            color = 'yellow'
            break
        }
        return (
          <Tag color={color} onClick={(e) => onClickStaus(e, record)}>
            <a>
              {status} &nbsp; <Icon type="edit" />
            </a>
          </Tag>
        )
      }
    },
    {
      title: 'Action',
      key: 'action',
      render: (text, record) => (
        <span>
          <Button
            type="primary"
            size="small"
            shape="circle"
            icon="edit"
            onClick={(e) => onClick(e, ACTION.UPDATE, record)}
          />
          <Divider type="vertical" />
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => onDelete(record.id)}>
            <Button type="danger" size="small" shape="circle" icon="delete" />
          </Popconfirm>
          <Divider type="vertical" />
          <Button
            size="small"
            shape="circle"
            icon="bars"
            style={{ backgroundColor: '#f5a623', color: '#fff', borderColor: '#f5a623' }}
            onClick={() => openHeroListModal(record)}
          />
        </span>
      )
    }
  ]

  async function saveWebhookDrafts(brandActivityId) {
    let failed = 0
    for (const draft of webhookDrafts) {
      try {
        await createActivityWebhook(brandActivityId, {
          name: draft.name,
          url: draft.url,
          enabled: draft.enabled
        })
      } catch (err) {
        failed++
      }
    }
    if (failed > 0) {
      message.error(
        `บันทึก Webhook ไม่สำเร็จ ${failed} รายการ กรุณาเพิ่มใหม่ในหน้าแก้ไขกิจกรรม`
      )
    }
  }

  async function onOk(data, coverList) {
    data.brandId = brandId

    let response = null

    if (action === ACTION.CREATE) {
      response = await dispatch(createBrandActivity(data))

      if (response.brandActivityId && coverList.length > 0) {
        await handleUploadActivityPhotoList(coverList, response.brandActivityId)
      }

      if (response.brandActivityId && webhookDrafts.length > 0) {
        await saveWebhookDrafts(response.brandActivityId)
      }
    } else {
      response = await dispatch(updateBrandActivity(data))

      if (formState.id && removedImages.length > 0) {
        for (const file of removedImages) {
          await deleteBrandActivityPhotoList(file.uid, formState.id)
        }
      }

      if (formState.id && coverList.length > 0) {
        await handleUploadActivityPhotoList(coverList, formState.id)
      }
    }

    setCoverList([])
    setRemovedImages([])
    setWebhookDrafts([])

    await setVisible(false)
    await dispatch(fetchBrandActivityList(brandId))
  }

  async function onDelete(id) {
    await dispatch(deleteBrandActivity(id))
    await dispatch(fetchBrandActivityList(brandId))
  }

  const onClick = (e, type, record) => {
    e.preventDefault()
    setWebhookDrafts([])
    setVisible(true)
    setAction(type)

    if (type === ACTION.UPDATE) {
      setFormState(record)
    }
  }

const openHeroListModal = (activity) => {
  const heroes = Array.isArray(activity.activityHeroList)
    ? activity.activityHeroList
    : [];

  Modal.info({
    icon: null,
    width: 900,
    maskClosable: true,
    okButtonProps: { style: { display: 'none' } },
    content: (
      <div className="hero-modal">
        <div className="hero-modal__title">
          รายชื่อฮีโร่ที่เข้าร่วมกิจกรรม
        </div>
        <div className="hero-table-container">
          <Table
            bordered
            dataSource={heroes}
            rowKey={(h) => h.heroId}
            pagination={false}
            size="middle"
            scroll={{ y: 420 }}
            columns={[
              {
                title: 'Hero ID',
                dataIndex: 'id',
                key: 'id',
                align: 'center',
              },
              {
                title: 'ชื่อ',
                dataIndex: 'name',
                key: 'name',
                align: 'center',
                render: (v) => v || '-',
              },
              {
                title: 'เบอร์โทร',
                key: 'phoneNumber',
                align: 'center',
                render: (_, row) => row.phoneNumber || row.phone || '-',
              },
            ]}
          />
        </div>
      </div>
    ),
  });
};


  const onClickStaus = (e, record) => {
    e.preventDefault()
    setVisibleStatus(true)
    setFormDataStatus(record)
  }

  const onCloseModalStatus = async () => {
    setFormDataStatus({})
    dispatch(fetchBrandActivityList(brandId))
    setVisibleStatus(false)
  }

  const onOkStatus = async (data) => {
    if (!_.isEmpty(formDataStatus)) {
      await dispatch(updateBrandActivityStatus(data))
    }

    await dispatch(fetchBrandActivityList(brandId))
    await setVisibleStatus(false)
    await setFormDataStatus({})
  }

  const onCloseModal = () => {
    setVisible(false)
    setFormState(null)
    setWebhookDrafts([])
  }

  const HeaderTable = () => {
    return (
      <Row type="flex">
        <Col span={12}>
          <span>Brand Activity</span>
        </Col>
        <Col span={12}>
          <Row type="flex" justify="end">
            <ButtonEx
              color="#6ebf4b"
              type="primary"
              onClick={(e) => onClick(e, ACTION.CREATE)}>
              <Icon type="plus" /> เพิ่มกิจกรรม
            </ButtonEx>
          </Row>
        </Col>
      </Row>
    )
  }

  return (
    <div>
      <PreviewImage
        imgUrl={previewImage}
        visible={visiblePreview}
        onClose={() => {
          setVisiblePreview(false)
          setPreviewImage(null)
        }}
      />
      <Table
        title={HeaderTable}
        loading={isLoading}
        bordered
        dataSource={brandActivityList}
        columns={columns}
        rowKey="id"
      />
      <BrandActivityForm
        action={action}
        formState={formState}
        visible={visible}
        onOk={onOk}
        onCancel={onCloseModal}
        coverList={coverList}
        setCoverList={setCoverList}
        removedImages={removedImages}
        setRemovedImages={setRemovedImages}
        onRemoveImage={handleRemoveActivityPhotoList}
        webhookDrafts={webhookDrafts}
        setWebhookDrafts={setWebhookDrafts}
      />

      <BrandActivityStatusForm
        visible={visibleStatus}
        formData={formDataStatus}
        onOk={onOkStatus}
        onCancel={onCloseModalStatus}
      />
    </div>
  )
}

export default BrandActivity
